import React from "react";
import PropTypes from "prop-types";
import { BaseOneToOneConversation } from "./OneToOneConversation/index.jsx";

export const OwnConversation = ({ members }) => {
  const id = members[0];

  return <BaseOneToOneConversation id={id} />;
};

OwnConversation.propTypes = {
  members: PropTypes.arrayOf(PropTypes.number),
};

OwnConversation.defaultProps = {
  members: [],
};
